import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getReportReserveProductSummarySlice = createSlice({
    name: "getReportReserveProductSummary",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getReportReserveProductSummarySlice_actions = getReportReserveProductSummarySlice.actions;
export var fetchData = _getReportReserveProductSummarySlice_actions.fetchData, fetchDataSuccess = _getReportReserveProductSummarySlice_actions.fetchDataSuccess, fetchDataFailure = _getReportReserveProductSummarySlice_actions.fetchDataFailure, resetState = _getReportReserveProductSummarySlice_actions.resetState;
export default getReportReserveProductSummarySlice.reducer;
